<template>
  <div>
    <el-form size="small">
      <el-row :gutter="15">
        <el-col :span="12">
          <DateForm
            ref="dateForm"
          />
        </el-col>
      </el-row>
      <el-row :gutter="15">
        <el-col :span="12">
          <el-form-item label="Carrier">
            <CarrierAutoComplete
              ref="carrierList"
              v-model="carrier"
              placeholder="All Carrier"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Portfolio">
            <PortfolioAutoComplete
              ref="portfolioList"
              v-model="portfolio"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col>
        <el-button
          type="primary"
          size="small"
          class="float-right"
          @click.native="downloadCSV()"
        >
          Generate Report
        </el-button>
      </el-col>
    </el-row>
    <Preview
      v-if="isShowPreview"
      title="Portfolio Freight Usage Report"
      :is-show.sync="isShowPreview"
      :configuration="configuration"
    />
  </div>
</template>

<script>
import DateForm from '@/components/Application/Reports/DateForm'
import CarrierAutoComplete from '@/components/Application/Reports/CarrierAutoComplete'
import PortfolioAutoComplete from '@/components/Application/Reports/PortfolioAutoComplete'
import Preview from '@/components/Application/Reports/Preview'

export default {
  components: {
    PortfolioAutoComplete,
    CarrierAutoComplete,
    DateForm,
    Preview
  },
  data () {
    return {
      pageTitle: 'Portfolio Freight Usage',
      breadcrumb: {
        name: 'Portfolio Freight Usage',
        route: { name: 'reports-invoice-uninvoiced' }
      },
      carrier: {},
      portfolio: {},
      form: {
        carrierId: null,
        dateTo: null,
        portfolioId: null
      },
      isShowPreview: false,
      configuration: null,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        },
        shortcuts: [{
          text: 'Today',
          onClick (picker) {
            picker.$emit('pick', new Date())
          }
        }, {
          text: 'Yesterday',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', date)
          }
        }, {
          text: 'A week ago',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }],
        formTem: null
      }
    }
  },
  methods: {
    setDate (date) {
      this.form.dateFrom = this.$moment(date[0]).format('YYYY-MM-DD HH:mm:ss')
      this.form.dateTo = this.$moment(date[1]).format('YYYY-MM-DD HH:mm:ss')
    },
    downloadCSV () {
      this.form.dateTo = this.$moment(this.form.dateTo).format('YYYY-MM-DD HH:mm:ss')
      this.$refs.dateForm.$refs.form.validate(async valid => {
        if (valid) {
          this.setDate(this.$refs.dateForm.form.value)
          if (this.$refs.carrierList.getCarrierId()) {
            this.form.carrierId = this.$refs.carrierList.getCarrierId()
            this.form.portfolioId = this.$refs.portfolioList.getPortfolioId()
          }
          this.formTem = this.form
          this.clean(this.formTem)

          this.configuration = {
            report: 'PortfolioFreightUsage',
            params: this.formTem
          }
          this.isShowPreview = true
        }
      })
    },
    clean (obj) {
      var propNames = Object.getOwnPropertyNames(obj)
      for (var i = 0; i < propNames.length; i++) {
        var propName = propNames[i]
        if (obj[propName] === null || obj[propName] === undefined) {
          delete obj[propName]
        }
      }
    }
  }
}
</script>
